import React from 'react';
import { Patient } from '@/types/Patient';
import { Procedure } from '@/types/Procedure';
import { ProcedureStep, ProcedureStepType } from '@/types/ProcedureStep';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import NextProcedures from '@/components/pages/kiosk/tablet/v2/NextProcedures';
import TimeOut2ActionButton from '@/components/pages/kiosk/tablet/v2/TimeOut2ActionButton';
import CurrentTime from '@/components/pages/kiosk/charting/components/CurrentTime';
import { useStyles } from '../ProcedureHandling';
import Button from '@material-ui/core/Button';

type ProcedureFooterSectionProps = {
  roomName: string;
  isPreviousPatient: boolean;
  nextProceduresInOperationRoom: Procedure[];
  status: string;
  patient?: Patient & { duration?: string };
  steps?: ProcedureStep[] | null;
  delayReasonLabel?: string;
  delayReasonSkipped?: boolean;
  onDelayReasonClick?: () => void;
};

export const ProcedureFooterSection = ({
  roomName,
  isPreviousPatient,
  nextProceduresInOperationRoom,
  status,
  patient,
  steps,
  delayReasonLabel,
  delayReasonSkipped,
  onDelayReasonClick,
}: ProcedureFooterSectionProps) => {
  const classes = useStyles();
  const isTimeOutStepEnabled = !!steps?.some(step => step.type === ProcedureStepType.TimeOut);

  return (
    <Box className={classes.footer}>
      <Box style={{ flex: 1 }}>
        <Typography>{roomName}</Typography>
      </Box>
      {!isPreviousPatient && (
        <Box className={classes.footerActions}>
          <NextProcedures nextProceduresInOperationRoom={nextProceduresInOperationRoom} />
          {isTimeOutStepEnabled && <TimeOut2ActionButton patient={patient} status={status} />}
        </Box>
      )}
      <Box
        style={{
          flex: 1,
          textAlign: 'right',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 12,
        }}
      >
        {delayReasonSkipped ? (
          <Button variant="contained" color="secondary" onClick={onDelayReasonClick}>
            Enter Delay Reason
          </Button>
        ) : delayReasonLabel ? (
          <Button variant="outlined" onClick={onDelayReasonClick}>
            Delay: {delayReasonLabel}
          </Button>
        ) : null}
        <Typography variant="h2" style={{ fontWeight: 'bold' }}>
          <CurrentTime />
        </Typography>
      </Box>
    </Box>
  );
};
